import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import _ from 'lodash';

export default async function getExteriorImage(modelName, elevation, callback) {
	let elevationUpper = elevation?.toUpperCase();
	firebase
		.database()
		.ref('/kavtek_buildingInfo/' + PROJECT_CODE.projectCode)
		.child(modelName)
		.on('value', (snapshot) => {
			let exteriorImgArr = [];
			let modelObj = snapshot.val();
			let priceList = modelObj?.priceList;
			let priceByElevation = _.filter(
				priceList,
				(el) => el?.id === elevationUpper
			);
			let imgList = priceByElevation?.[0]?.images;
			if (imgList) {
				_.map(imgList, function (el) {
					if (el?.url) {
						exteriorImgArr.push(el?.url);
					}
				});
			}
			callback(exteriorImgArr);
		});
	// return ['url 1', 'url 2',...]
	// console.log('getExteriorImage');
	// var storageRef = firebase
	// 	.storage()
	// 	.ref(PROJECT_CODE.projectCode + '/buildingExteriors/' + modelName);
	// const fetchImages = async () => {
	// 	let result = await storageRef.child(elevation).listAll();

	// 	let urlPromises = result.items.map((imageRef) =>
	// 		imageRef.getDownloadURL()
	// 	);

	// 	return Promise.all(urlPromises);
	// };

	// console.log('storageRef', storageRef);

	// const loadImages = async () => {
	// 	const urls = await fetchImages();

	// 	console.log('loadImages', urls);
	// 	callback(urls);
	// };

	// loadImages();
}
